/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tag_VipInputs */

const cs_tag_vip = /** @type {(inputs: Tag_VipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VIP`)
};

const en_tag_vip = /** @type {(inputs: Tag_VipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VIP`)
};

/**
* | output |
* | --- |
* | "VIP" |
*
* @param {Tag_VipInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tag_vip = /** @type {((inputs?: Tag_VipInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tag_VipInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tag_vip(inputs)
	return cs_tag_vip(inputs)
});